import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";

/**
 * FlirtMachine OAuth (SSO) return route — completes the Clerk social-login
 * round-trip for `<SignIn routing="path">` at `/flirtmachine/login`.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/flirtmachine/login/sso-callback")({
  component: FlirtMachineSSOCallback,
});

export function FlirtMachineSSOCallback() {
  return <AuthenticateWithRedirectCallback />;
}
